export default {
  fields: {
    price: 'Prezzo',
    tax: 'Tassa',
    visible_to: 'Visibile a',
  },
  buttons: {
    add_price: '+ Aggiungi prezzo',
  },
};
